// extracted by mini-css-extract-plugin
export default {"app":"App_app__-lxHV","main":"App_main__P9x1h"};